// ============================================================================
// REQ-2026-0007 — Slot colour palette for the Triaxial Analysis range-typed
// picker.
//
// Picked for accessibility: each colour has ~contrast 4.5:1 against white
// for the small text on coloured pills and ~3:1 against a typical chart
// background. Translucent band variants are derived by appending an alpha
// suffix at 15% opacity.
//
// Slot semantics:
//   Max      — max deviator stress q within [from, to]
//   Peak     — max effective stress ratio σ'₁/σ'₃ within [from, to]
//   End      — max axial strain εₐ within [from, to] (= last point)
//   Residual — min deviator stress q within [from, to] (post-peak)
// ============================================================================

export type TriaxialSlot = 'max' | 'peak' | 'end' | 'residual';

export const TRIAXIAL_SLOT_COLORS: Record<TriaxialSlot, string> = {
  max: '#2f5d8a',     // blue
  peak: '#2e8b57',    // green
  end: '#c7860b',     // orange
  residual: '#c0392b', // red
};

/**
 * Translucent band colour for a slot.
 * Hex with '26' suffix ≈ 15% alpha (#xxxxxx + 0x26/0xFF ≈ 0.149).
 */
export function bandColorFor(slot: TriaxialSlot): string {
  return `${TRIAXIAL_SLOT_COLORS[slot]}26`;
}

export const TRIAXIAL_SLOT_LABEL: Record<TriaxialSlot, string> = {
  max: 'Max',
  peak: 'Peak',
  end: 'End',
  residual: 'Residual',
};

export const TRIAXIAL_SLOT_ORDER: readonly TriaxialSlot[] = ['max', 'peak', 'end', 'residual'] as const;
